import {Appearance} from '@stripe/stripe-js';
import {main} from './colors';

export const paymentAppearance: Appearance = {
    theme: 'flat',
    variables: {
        fontWeightNormal: '500', borderRadius: '2px', colorBackground: 'white',
        colorPrimary: main, colorPrimaryText: 'white', spacingGridRow: '15px',
    },
    rules: {
        '.Label': {marginBottom: '6px'},
        '.Tab, .Input, .Block': {boxShadow: '0px 3px 10px rgba(18, 42, 66, 0.08)', padding: '12px'},
    },
};
